import {Note} from '../note.model';

export class NoteViewModel extends Note {

    public parentId: number;
    public appendedNoteCount: number;
    public userFullName: string;

    public noteIdentificationValue: number;
    public noteIdentificationTypeId: number;
    public childNotes: NoteViewModel[];

    // NotMapped
    public rowId: number;
    // NotMapped
    public businessUnitId?: number;
    // NotMapped
    public userIsOriginalAuthor = true;
}
